import { ReactNode } from 'react'

export const SettingsSectionContainer = ({ children }: { children: ReactNode }) => (
  <div style={{ flex: 0.4, display: 'flex', flexDirection: 'column', padding: '20px 0 20px' }}>
    {children}
  </div>
)
